import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiHelper } from 'src/app/core/services/api-helper';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private readonly apiHelper: ApiHelper) {}

  getReportFilter(reportId) {
    const data = { reportId: reportId };
    return this.apiHelper.postWithAccessToken(`${environment.API_URL}GetReportFilter`, data);
  }

  getFullReportList(staffId: number) {
    return this.apiHelper.getWithAccessToken(`${environment.API_URL}v2/Reporting/GetList/Full/${staffId}`);
  }

  getSubReportList(staffId: number) {
    return this.apiHelper.getWithAccessToken(`${environment.API_URL}v2/Reporting/GetList/Sub/${staffId}`);
  }

  getFavouriteReportList(staffId: number) {
    return this.apiHelper.getWithAccessToken(`${environment.API_URL}v2/Reporting/GetList/Favourites/${staffId}`);
  }
}
